export const DEFAULT_BOTTOM_MARGIN = 30;
